/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.48.4 of "Products"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { GetColorsResponse } from '../models/GetColorsResponse';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class ColorsService {

    /**
     * List all possible colors
     * Get a list of all possible product colors.
     *
     * @returns GetColorsResponse Returns list of all possible colors
     * @throws ApiError
     */
    public static getPublicProductsCustomizationColors(
        clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
        public static getPublicProductsCustomizationColors(
            clientOptionsOverride?: Partial<ClientOptions>): Promise<GetColorsResponse>;
            public static getPublicProductsCustomizationColors(
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'GET',
                        url: '/public/products/customization/colors',
                    });
                }

            }
